import lodashGet from "lodash/get";
import React, { ComponentPropsWithoutRef } from "react";
import { PillarTableBaseColumnCellValuePathProps } from "shared/components/pillar-table/columns/PillarTableColumn";
import { usePillarTableRowContext } from "shared/components/pillar-table/row/PillarTableRowContext";
import { defaultEmailFromProfile } from "shared/helpers/profile/defaultEmailFromProfile";
import { ProfileView } from "shared/mappers/database/profile/profile";

export type PillarTableColumnProfileEmailProps<T> =
  PillarTableBaseColumnCellValuePathProps<T> & ComponentPropsWithoutRef<"div">;

const PillarTableColumnProfileEmail = <T,>({
  cellValuePath,
  className,
  ...props
}: PillarTableColumnProfileEmailProps<T>) => {
  const { rowValue } = usePillarTableRowContext();
  const profile = cellValuePath
    ? (lodashGet(rowValue, cellValuePath) as ProfileView)
    : (rowValue as ProfileView);

  const email = defaultEmailFromProfile(profile);

  return (
    <div className={className} {...props}>
      {email ?? ""}
    </div>
  );
};

export default PillarTableColumnProfileEmail;
